import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { consumeOnboardingLink } from '../../Services/APIs/authentication';
import { setClinicAccessToken, setClinicDetails } from '../../Utils/clinicAuth';
import useResolveDestination from '../../Dashboard/Auth/useResolveDestination';

const INVALID_LINK_MESSAGE = "This link is invalid or has expired. Please ask for a new one.";

const OnboardingConsume = () => {
    const [searchParams] = useSearchParams();
    const { resolveDestination, statusError } = useResolveDestination();
    const [error, setError] = useState('');

    useEffect(() => {
        if (statusError) setError(statusError);
    }, [statusError]);

    useEffect(() => {
        let cancelled = false;
        const token = searchParams.get('tok');

        const run = async () => {
            if (!token) {
                setError(INVALID_LINK_MESSAGE);
                return;
            }
            try {
                const response = await consumeOnboardingLink(token);
                if (cancelled) return;
                setClinicAccessToken(response.data?.data?.accessToken);
                setClinicDetails(response.data?.data?.clinic);
                await resolveDestination();
            } catch (err) {
                if (cancelled) return;
                const message = err?.response?.data?.message || err?.data?.message || INVALID_LINK_MESSAGE;
                setError(message);
            }
        };

        run();
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams]);

    return (
        <div className="cv2-dark cv2-onboard-bg h-dvh flex items-center justify-center px-6">
            <style>{`.cv2-onboard-bg { background: radial-gradient(ellipse at 20% 5%, #192a20 0%, #101b15 27.5%, #080c09 55%); }`}</style>
            {error ? (
                <p className="font-aeonik text-sm leading-[22px] text-center normal-case text-cv2-foreground">
                    {error}
                </p>
            ) : (
                <Loader2 className="w-6 h-6 text-claraview-secondary animate-spin" strokeWidth={2} />
            )}
        </div>
    );
};

export default OnboardingConsume;
